const ComponentErrorHandler = ({ views }) => {
  //isPrimary is boolean
  if (!Array.isArray(views))
    throw new Error("Component TabNavigation: views must be an array");
};

export default ComponentErrorHandler;
